import * as React from "react";
import { RouteComponentProps, useParams, withRouter } from "react-router";
import { URLS, useAccountSettings } from "../../../utils";
import { PageWrapper } from "../../../components/PageWrapper";
import { camelCase } from "lodash";
import { Players } from "./Players";
import { Menu } from "semantic-ui-react";
import { Assistants } from "./Assistants";
import { WebComponents } from "@/interfaces";

type Props = RouteComponentProps;

const UsersFC: React.FC<Props> = ({ history }) => {
  const tabs: { title: string; key: string; component: any }[] = [];

  const { hasReadPermission } = useAccountSettings();
  if (hasReadPermission(WebComponents.PLAYERS)) {
    tabs.push({ title: "Players", key: "players", component: Players });
  }
  if (hasReadPermission(WebComponents.ASSISTANTS)) {
    tabs.push({ title: "Assistants", key: "assistants", component: Assistants });
  }

  var { tab } = useParams<{ tab: string }>();
  const [selectedTabKey, setSelectedTabKey] = React.useState<string>(tab || tabs[0].key || "");
  React.useEffect(() => {
    if (tab) setSelectedTabKey(tab);
  }, [tab]);

  React.useEffect(() => {
    history.replace(URLS.coach.usersTab.replace(":tab?", camelCase(selectedTabKey)));
  }, [selectedTabKey]);

  const TabComponent = React.useMemo(() => {
    return (tabs.find(tab => tab.key === selectedTabKey) || tabs[0]).component;
  }, [selectedTabKey, tabs]);

  return (
    <PageWrapper title="Users" hideSeparator>
      <Menu pointing secondary className="mt-0">
        {tabs.map(tab => {
          return (
            <Menu.Item
              key={`tab-${tab.key}`}
              name={tab.title}
              active={selectedTabKey === tab.key}
              onClick={() => setSelectedTabKey(tab.key)}
            />
          );
        })}
      </Menu>
      <TabComponent />
    </PageWrapper>
  );
};

export const Users = withRouter(UsersFC);
